export default __webpack_public_path__ + "static/media/csharp.8f35e178.svg";